export default __webpack_public_path__ + "static/media/uploadFileIcon.bc0eda13.svg";